
<template>
	<svg
		width="7"
		height="11"
		viewBox="0 0 7 11"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3.80168 5.70216L0.266183 2.16665L1.6804 0.752441L6.63009 5.70214L1.6804 10.6519L0.266174 9.23775L3.80168 5.70216Z"
			fill="#4F58F5"
		/>
	</svg>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

